'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _UITileSection = require('UIComponents/tile/UITileSection');

var _UITileSection2 = _interopRequireDefault(_UITileSection);

var _LegalConsentOptions = require('MeetingsBase/models/LegalConsentOptions');

var _LegalConsentOptions2 = _interopRequireDefault(_LegalConsentOptions);

var _LegalConsentFields = require('FormsCommonComponents/LegalConsentFields');

var _LegalConsentFields2 = _interopRequireDefault(_LegalConsentFields);

var _LegalConsent = require('FormsCommonComponents/lib/LegalConsent');

var _LegalConsent2 = _interopRequireDefault(_LegalConsent);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalConsentInputs = function LegalConsentInputs(_ref) {
  var legalConsentOptions = _ref.legalConsentOptions,
      legalConsentResponses = _ref.legalConsentResponses,
      setGivenConsent = _ref.setGivenConsent;

  var previewModel = new _LegalConsent2.default(legalConsentOptions.convertToJSON());

  return _react2.default.createElement(
    _UITile2.default,
    { style: { background: _colors.KOALA }, compact: true },
    _react2.default.createElement(
      _UITileSection2.default,
      { className: 'p-bottom-0', style: { wordWrap: 'break-word' } },
      _react2.default.createElement(_LegalConsentFields2.default, {
        legalConsentRecord: previewModel,
        legalConsentResponses: legalConsentResponses,
        onCommunicationCheckboxChange: setGivenConsent
      })
    )
  );
};

LegalConsentInputs.propTypes = {
  legalConsentOptions: _react.PropTypes.instanceOf(_LegalConsentOptions2.default).isRequired,
  legalConsentResponses: _react.PropTypes.instanceOf(_immutable.List),
  setGivenConsent: _react.PropTypes.func.isRequired
};

exports.default = LegalConsentInputs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/input/LegalConsentInputs.js
// module id = 486
// module chunks = 0